/*
=============================================
   CONTENT ACCESS (client side)                                (2026-10-08)
=============================================
Asks the API which walled Training areas this visitor may see. Shared by the
in-app Training tab and the public /training.html page.

   GET /me/content-access  ->  { ok, all, areas: [slug...], audiences: [slug...] }

This is PRESENTATION ONLY. It decides which tiles to draw. The enforcement is
the Cloudflare worker, which refuses an area's chunk and its files to anyone
the same endpoint does not grant, so a visitor who edits this answer in the
console gets a list of loaders that all fail.

Not signed in (401), API unreachable, or an old API without the route (404):
all of them come back as "nothing beyond the public areas", never as an error,
so the public material always renders.
*/
import { api } from "./api.js";

let cached = null;

export async function getContentAccess() {
   if (cached) return cached;
   try {
      const res = await api("/me/content-access");
      if (!res.ok) return { ok: false, signedIn: res.status !== 401, all: false, areas: [], audiences: [] };
      const body = await res.json();
      cached = {
         ok: true,
         signedIn: true,
         all: body.all === true,
         areas: Array.isArray(body.areas) ? body.areas : [],
         audiences: Array.isArray(body.audiences) ? body.audiences : [],
      };
      return cached;
   } catch {
      return { ok: false, signedIn: false, all: false, areas: [], audiences: [] };
   }
}
